import * as React from "react";

export const IconPolygonArrowLeft = (
	props: React.SVGProps<SVGSVGElement>
): React.JSX.Element => (
	<svg
		width="9"
		height="20"
		viewBox="0 0 9 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M8.25 9.52637L5.64421e-08 19.0526L8.89256e-07 8.73774e-05L8.25 9.52637Z"
			fill="currentColor"
		/>
	</svg>
);
